import axios from "axios";
import * as Endpoints from "../entities/Endpoints";

const axiosPublicInstance = axios.create({
  baseURL: Endpoints.API_ENDPOINT,
});

axiosPublicInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Public API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);

export default axiosPublicInstance;
